import { Link } from 'react-router-dom';
import { reviewTopics } from '@/mocks/categories';

export default function ReviewSection() {
  return (
    <section id="reviews" className="w-full bg-background-100 py-14 md:py-20">
      <div className="max-w-6xl mx-auto px-6 md:px-10">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            Basetao Review Center
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            Before choosing any shopping agent, understanding reviews, shipping costs, warehouse policies, and user experience is essential. Our Basetao Review Center provides independent guides covering everything buyers need before making decisions.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {reviewTopics.map((topic) => (
            <Link
              key={topic.title}
              to="/basetao-spreadsheet-ultimate-guide"
              className="group flex flex-col gap-3 p-5 md:p-6 rounded-lg bg-background-50 border border-background-200/70 hover:border-primary-300 transition-all duration-300 cursor-pointer"
            >
              <div className="w-10 h-10 rounded-lg bg-primary-100/70 flex items-center justify-center group-hover:bg-primary-200 transition-colors">
                <i className={`${topic.icon} text-lg text-primary-600`}></i>
              </div>
              <h3 className="text-base md:text-lg font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors">
                {topic.title}
              </h3>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                {topic.desc}
              </p>
            </Link>
          ))}
        </div>

        <div className="text-center mt-8">
          <Link
            to="/basetao-spreadsheet-ultimate-guide"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            Read Complete Guide
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-sm"></i>
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
}